module.exports = __webpack_public_path__ + "img/1a.5ab32279.png";